import _slicedToArray from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var pickElementFromSet = function pickElementFromSet(set, predicate) {
  var matchingElements = Array.from(set).filter(predicate);

  if (matchingElements.length > 1) {
    throw Error('More than one element was found.');
  }

  if (matchingElements.length === 0) {
    throw Error('No element was found.');
  }

  var _matchingElements = _slicedToArray(matchingElements, 1),
      matchingElement = _matchingElements[0];

  set.delete(matchingElement);
  return matchingElement;
};